export class DeviceAbility {
  /**
   * å¤å¶å°ç²è´´æ¿
   * @param text 
   * @returns 
   */
  public static copyToClipboard(text): boolean {
    const windowRef: any = window;
    if (windowRef.clipboardData && windowRef.clipboardData.setData) {
      return windowRef.clipboardData.setData("Text", text);
    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
      var textarea = document.createElement("textarea");
      textarea.textContent = text;
      textarea.style.position = "fixed";
      document.body.appendChild(textarea);
      textarea.select();
      try {
        return document.execCommand("copy");
      } catch (ex) {
      } finally {
        document.body.removeChild(textarea);
      }
    }
    return false;
  }
}